import { setStartTime } from '../../search-and-filter-schema/protected';
const updateStartTime = (filters, value) => {
  return setStartTime(value, filters);
};
export default updateStartTime;